// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"179":"main","535":"login"}[chunkId] + "." + {"179":"4a25aef3","535":"64a97f00"}[chunkId] + ".css";
};